import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import { DateTime } from 'luxon'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

function checkValidEidaExpiryDate(dateString) {
  let minEidaExpiryDate = DateTime.now().plus({ days: 29 }).toFormat('YYYY/MM/DD')
  let eidaExpiryDate = DateTime.fromFormat(dateString, 'dd/MM/yyyy').toMillis()
  return eidaExpiryDate > new Date(minEidaExpiryDate)
}
export default async function () {
  const formStore = useFormStore()
  const { enableServiceRecaptcha } = formStore.extraMap
  const { oldEidaExpiryDate } = formStore.form.values

  if (enableServiceRecaptcha) {
    doNotify(i18n.global.t('warningTitle'), i18n.global.t('captchaNotProcessed'))
    return false
  }
  if (oldEidaExpiryDate && !checkValidEidaExpiryDate(oldEidaExpiryDate)) {
    doNotify(i18n.global.t('warningTitle'), i18n.global.t('CannotCompletedReplacement'))
    return false
  }
  return true
}
